import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import ls from 'local-storage'
import env from '../env.json'

Vue.use(VueAxios, axios)

const webApi = axios.create({
  baseURL: env.api_base_url
})

webApi.interceptors.request.use((config) => {
  const token = ls.get('token')
  if (token) {
    config.params = {
      token
    }
  }
  return config
})

/**
 * We are following Google Resource Oriented API Design
 *
 * Different methods (GET, POST, etc...)
 * for the same URI can have only one name:"->name('route_name')"
 *
 * @see https://cloud.google.com/apis/design/resources
 */

export default {
  signin: (data) => {
    return webApi.post('auth/signin', data)
  },
  register: (data) => {
    return webApi.post('auth/register', data)
  },
  getFeaturedProductsData: (locationId) => {
    return webApi.get(`featured-products/${locationId}`)
  },
  listMenu: (locationId) => {
    return webApi.get(`list-menu/${locationId}`)
  },
  listLunchBoxes: (locationId) => {
    return webApi.get(`offers/${locationId}`)
  },
  getSettings: (locationId) => {
    return webApi.get(`settings/${locationId}`)
  },
  getStatus: () => {
    return webApi.get('customer/status')
  },
  editCustomer: (data) => {
    return webApi.post('customer/edit', data)
  },
  manageCustomerInCheckout: (data) => {
    return webApi.post('manage-customer-in-checkout', data)
  },
  placeOrder: (data) => {
    return webApi.post('place-order', data)
  },
  getOrder: (data) => {
    return webApi.post('get-order', data)
  },
  getCustomerPaymentSources: (locationId) => {
    return webApi.get(`customer/payment-sources?location_id=${locationId}`)
  },
  deleteCustomerDefaultPaymentSource: (locationId) => {
    return webApi.post(`customer/delete-default-payment-source?location_id=${locationId}`)
  },
  getCustomerOrders: () => {
    return webApi.get('customer/orders')
  },
  getDiscount: (code) => {
    return webApi.get(`get-discount?code=${code}`)
  },
  sendMessage: (data) => {
    return webApi.post('send-message', data)
  },
  restorePassword: (data) => {
    return webApi.post('auth/restore-password', data)
  },
  setNewPassword: (data) => {
    return webApi.post('auth/set-new-password', data)
  },
  getCustomerByPasswordToken: (data) => {
    return webApi.post('auth/get-customer-by-password-token', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js